import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SelectAllIcon from '@material-ui/icons/SelectAll';
import FilterListIcon from '@material-ui/icons/FilterList';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ActionText from '../../core/ActionText';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../../core/style/gstheme';
import ConceptDisplay from './ConceptDisplay';
import QuickFilter from './QuickFilter';

const MAX_ITEMS = 1000;

class SearchResults extends Component {

  render() {

    const { classes, graph, concepts, defaultLang, viewLang, project, columns, handleSelectionChange,
      addFilter, excludeFilterProperties, ontologyProjectAssociation, onAddQuickFilter, classSelector,
      taxonomies, viewOptions, editMode, onSelectRow, selectedRows, onSelectAll, allowFilters } = this.props;

    const notSelected = concepts ? concepts.filter(c => !selectedRows.includes(c)).length : 0;

    return (
      <div data-test="search-results">
        <div style={{
          width: '100%'
        }}>
          <TableContainer style={{
            overflowX: "initial"
          }}>
            <Table stickyHeader data-test="search-results-viewer">
              <TableHead data-test="results-header">
                <TableRow>
                  {editMode &&
                    <TableCell data-test={"header-edit-mode"} component="th" className={classes.tableHeadingPlain}>
                    </TableCell>
                  }
                  {
                    [...viewOptions, { label: "(View) In Scheme" }].map((col, index) => {
                      if (!col.heading && (!columns || index >= columns.length || columns[index])) {
                        return <TableCell
                          data-test={"header-" + index}
                          key={index}
                          component="th"
                          className={classes.tableHeadingPlain}>
                          <span>
                            {col.label}
                          </span>
                        </TableCell>;
                      }
                      else return null;
                    })
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                  {editMode &&
                    <TableCell data-test={"header-edit-mode"} component="th" className={classes.tableHeadingPlain}>
                      <span style={{ marginLeft: 4 }}>
                        <Tooltip title="Select all on this page">
                          <span>
                            <IconButton
                              disabled={notSelected === 0 || !concepts || selectedRows.length > MAX_ITEMS - notSelected}
                              data-test="select-all"
                              className={classes.smallIconButton}
                              size="small"
                              onClick={() => onSelectAll(concepts)}>
                              <SelectAllIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </span>
                    </TableCell>
                  }
                  {
                    [...viewOptions, { label: "(View) In Scheme" }].map((col, index) => {
                      if (!col.heading && (!columns || index >= columns.length || columns[index])) {
                        return <TableCell
                          data-test={"header-" + index}
                          key={index}
                          component="th"
                          className={classes.tableHeadingPlain}>
                          {col.canFilter && allowFilters &&
                            <div style={{ display: 'flex', justifyContent: col.quickFilter ? 'flex-start' : 'flex-end' }}>
                              {col.quickFilter &&
                                <div>
                                  {col.format === "class" ?
                                    classSelector
                                    :
                                    <QuickFilter
                                      dataTest={"filter-input-" + index}
                                      onAddFilter={onAddQuickFilter}
                                      property={col.value}
                                      exclude={[]} />
                                  }
                                </div>
                              }
                              {(col.format !== "class" || classSelector) &&
                                <div data-test={"add-filter-" + index} style={{ marginLeft: 4, marginTop: 2 }}>
                                  <Tooltip title="Add a filter">
                                    <span>
                                      <IconButton
                                        data-test="add-filter"
                                        disabled={excludeFilterProperties.includes(col.value)}
                                        className={classes.smallIconButton}
                                        size="small"
                                        onClick={() => addFilter(col)}>
                                        <FilterListIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                </div>
                              }
                            </div>
                          }
                        </TableCell>;
                      }
                      else return null;
                    })
                  }
                </TableRow>
              </TableBody>
              <TableBody data-test="results-body">
                {concepts && concepts.map((concept) => <ConceptDisplay
                  suppressLoading={true}
                  editMode={editMode}
                  canSelect={selectedRows.length < MAX_ITEMS}
                  selected={selectedRows.includes(concept)}
                  ontologyProjectAssociation={ontologyProjectAssociation}
                  onSelectRow={onSelectRow}
                  viewOptions={viewOptions}
                  display={columns}
                  key={concept}
                  taxonomies={taxonomies}
                  handleSelectionChange={handleSelectionChange}
                  project={project}
                  viewLang={viewLang}
                  defaultLang={defaultLang}
                  id={concept}
                  graph={graph} />)}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {!concepts && <div style={{ clear: 'both' }}><ActionText offset="25px">No results.</ActionText></div>}
      </div>
    );
  }

}

SearchResults.defaultProps = {
  excludeFilterProperties: [],
  ontologyProjectAssociation: []
};

SearchResults.propTypes = {
  classes: PropTypes.object,
  concepts: PropTypes.array,
  classSelector: PropTypes.object,
  allowFilters: PropTypes.bool,
  onSelectAll: PropTypes.func,
  addFilter: PropTypes.func,
  excludeFilterProperties: PropTypes.array,
  onAddQuickFilter: PropTypes.func,
  onSelectRow: PropTypes.func,
  selectedRows: PropTypes.array,
  ontologyProjectAssociation: PropTypes.array,
  onPageSizeChange: PropTypes.func,
  handleSelectionChange: PropTypes.func,
  viewOptions: PropTypes.array.isRequired,
  project: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string.isRequired,
  taxonomies: PropTypes.array.isRequired,
  graph: PropTypes.string.isRequired
};

export default withStyles(styles)(SearchResults);